import React from "react";
import { CircularProgress } from "@mui/material";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <CircularProgress color="primary" className="loader-spinner" />
    </div>
  );
};

export default Loader;